export default __webpack_public_path__ + "static/mowens-64d8868bcde78589a5f86dcb0bf7f503.jpg";